// extracted by mini-css-extract-plugin
module.exports = {"vocCardWrap":"Ah1fq","mobileScroll":"ZkIUc"};